export default class Character {

    constructor(characterJson) {

        this.name = characterJson.name
        this.basePath = characterJson.basePath
        this.neutre = characterJson.neutre
        this.posePath = '/pose.crunch/'
        this.transitionPath = '/transition.crunch/'

        this.loadedAttitude = []
        this.loadingAttitude = []

        this.attitudeRandomizer = characterJson.attitudeRandomizer
        this.attitudes = characterJson.attitudes

        this.lastUpdateStamp = 0
        this.currentHowl = null
        this.reactComponentUpdateCallBack = null

        this.speechChar = new window.SpeechCharacter(this.name, characterJson.options);
    }

    loadNeutral() {
        return this.loadAnim('neutre', this.basePath + this.neutre)
        .then(() => this.loadAnimRequiredFiles())
    }

    isLoading() {
        return this.loadingAttitude.length() <= 0
    }

    loadAttitudes(names) {
        let loads = []

        names.forEach(name => {
            if(this.loadedAttitude.indexOf(name) !== -1) {

            }
            else if (this.loadingAttitude.indexOf(name) !== -1) {

            }
            else if(this.attitudes.indexOf(name) !== -1) {
                this.loadingAttitude.push(name)
                loads.push(this.loadAttitude(name))
            }
            else {
                let rand = this.attitudeRandomizer.find(randomizer => randomizer.key === name)
                if(rand) {
                    loads.push(this.loadAttitudes(rand.chances.map(chance => chance.key)))
                    this.loadedAttitude.push(name)
                }
                else console.error('No attitude data for this key :', name)
            }
        })
        return Promise.all(loads)
    }

    loadAttitude(name) {
        return new Promise((resolve, rejected) => {
            this.loadPose(name)
            .then(() => this.loadTransition(name))
            .then(() => {
                this.loadingAttitude = this.loadingAttitude.filter(attitude => attitude !== name)
                this.loadedAttitude.push(name)
            })
            .then(() => resolve())
            .catch(err => rejected(err))
        })
    }

    loadPose(name) {
        return this.loadAnim(name + '.pose', this.basePath + name + this.posePath)
    }

    loadTransition(name) {
        return this.loadAnim(name, this.basePath + name + this.transitionPath)
    }

    loadAnim(anim_name, path) {
      const json_path = path + "anim.json";
        return new Promise((resolve, rejected) => {
            fetch(json_path)
            .then(res => res.text())
            .then(json_txt => {

                this.speechChar.addAnim(anim_name, json_txt, path);
                resolve()
            })
            .catch(err => rejected(err))
        })
    }

    loadAnimRequiredFiles() {
        return new Promise((resolve, rejected) => {
            let promises = []

            this.speechChar.getFilesToLoad().forEach(file => {
                promises.push(new Promise((_resolve, _rejected) => {


                    fetch(file.basePath + file.fileName)
                    .then(res => res.arrayBuffer())
                    .then(buffer => {
                        this.speechChar.setAnimData(file.animationName, file.fileName, buffer);
                        _resolve()
                    })
                    .catch(err => _rejected(err))
                }))
            })
            Promise.all(promises)
            .then(() => {
                resolve()
            })
            .catch(err => rejected(err))
        })
    }

    start() {
        requestAnimationFrame(this.uL.bind(this))
    }

    registerUpdate(reactUpdate) {
        this.reactComponentUpdateCallBack = reactUpdate
    }

    lastTS = 0
    uL(currentTS) {
        let dt = (currentTS - this.lastTS) / 1000
        dt *= 2

        if(this.currentHowl && this.currentHowl.playing()) {
            this.speechChar.update(dt, this.currentHowl.seek())
        }
        else {
            this.speechChar.update(dt, -1)
        }

        this.lastTS = currentTS

        if(this.reactComponentUpdateCallBack !== null) {
            try {
                this.reactComponentUpdateCallBack(this.speechChar.getBuffer(), this.speechChar.getWidth(), this.speechChar.getHeight())
            }
            catch(e) {
                console.error(e)
            }
        }
        requestAnimationFrame(this.uL.bind(this))
    }

    startDial(howl, attitude, text, phonem) {
        this.currentHowl = howl

        let duration = this.currentHowl.duration() * 2
        let attTiming = (duration*1000) +":"+ this.checkAttitude(attitude)

        let textTiming = (duration*1000) +":"+ text



        // if(text) {
        //     this.speechChar.setContentRaw("bla bla bla bla bla bla bla", "concentration1", null, duration, phonem) // TODO : gérer le text temp
        // }
        // else {
            //text,attitudeTimings,textTimings,duration,phonemeContent
            // console.log("text, attTiming, null , duration, phonem", text, attTiming, null , duration, phonem)
            this.speechChar.setContentRaw(text, attTiming, null , duration, phonem)
        // }
    }

    stopDial() {
        this.currentHowl = null
        // this.speechChar.setContentRaw("bla bla bbbla bla bla bla", 'neutre', null , 1000, null)
    }

    checkAttitude(attitude) {
        let randomizer = this.attitudeRandomizer.find(randomizer => randomizer.key === attitude)
        if(randomizer) {
            let test = Math.random()
            let temp = null
            randomizer.chances.forEach(random => {
                if(test < random.probability && temp === null) {
                    temp = random.key
                }
            })
            if(temp) return temp
            console.error("No attitude matching probability ", test, " returning last random possibility")
            return this.randomizedAttitude.at(-1).key
        }
        else {
            return attitude;
        }
    }
}
